import React, { useCallback, useEffect, useRef, useState } from "react";
// import React, { useState } from 'react';
// import { useCallback } from 'react';
import Chip from "@mui/material/Chip";
import { Card, CardBody, Col, Row } from "reactstrap";
import DeactivateUserModal from "../../components/Common/DeactivateUserModal";
import CustomDropdown from "../../components/CustomComponents/CustomDropdown";
import { getUserRoleListReq } from "../../service/usersService";

const UserCardDetails = (user) => {
  const {usersData, setOpenModal, setEditUserData, setSelectedItems, openDeactivateModal, setOpenDeactivateModal,  setSelectedUserEmail, setResetPasswordModal} = user
  const [userRole, setUserRole] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const effectCalled = useRef(false);
  const color = usersData?.status === "active" ? "#2ecc71" : "red";
  const roleData = useCallback(async (body) => {
    const response = await getUserRoleListReq(usersData.role);
    if (response && response.payload) {
      setUserRole(
        response?.payload.roles.filter(
          (role) => role._id === usersData.role
        )[0].title
      );
    }
  });

  useEffect(() => {
    if (!effectCalled.current) {
      roleData();
      effectCalled.current = true;
    }
  }, []);
  // warehouseData();

  return (
    <Card
      style={
        usersData?.associatedBranch?.isPrimary
          ? { border: "2px solid blue" }
          : { border: "none" }
      }
    >
      <CardBody>
        <Row className="align-items-center">
          <Col xs="auto">
            <div
              className="circle-active"
              style={{
                backgroundColor: color,
                width: "15px",
                height: "15px",
                borderRadius: "50%",
              }}
            ></div>
          </Col>
        <Col className="d-flex justify-content-between align-items-center">
        <h3 className="card-title mb-0">
          {usersData?.firstName} {usersData?.lastName}
        </h3>
        <CustomDropdown
          isOpen={isDropdownOpen}
          direction="down"
          toggle={() => setIsDropdownOpen(!isDropdownOpen)}
          items={[
            {
              label: "Edit",
              onClick: () => {
                setOpenModal(true);
                setEditUserData(usersData);
                setSelectedItems(usersData?.associatedWarehouses)
              },
            },
            // TODO: Phase II deactivate user
            // {
            //   label: "Deactivate",
            //   onClick: () => {
            //     setOpenDeactivateModal(true);
            //   },
            // },
          ]}
        />
        </Col>

        </Row>
            <DeactivateUserModal
              userData={usersData}
              userId={usersData?._id}
              openModal={openDeactivateModal}
              setOpenModal={setOpenDeactivateModal}
            //   notify={} 
            />
        <Row className="mt-3">
          <Col>
            <div className="d-flex flex-wrap">
              {usersData?.associatedWarehouses.map((warehouse, index) => (
                <Chip key={index} label={warehouse.code} className="mr-2" />
              ))}
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs="6">
            <p>Role</p>
          </Col>
          <Col xs="6">
            <p>{userRole}</p>
          </Col>
          <Col xs="6">
            <p>Contact</p>
          </Col>
          <Col xs="6">
            <p>{usersData?.email}</p>
          </Col>
        </Row>
      </CardBody>
      {usersData?.associatedBranch?.isPrimary ? (
        <div
          style={{
            fontSize: "0.9em",
            backgroundColor: "#e5f3f7",
            width: "8.5rem",
            borderRadius: "0.2rem",
            margin: "0 17rem",
            marginLeft: "34.99rem",
            textAlign: "center",
          }}
        >
          Primary Warehouse
        </div>
      ) : (
        <div></div>
      )}
    </Card>
  );
};

export default UserCardDetails;
